export enum SubmittalJobMatchCalculationTypes {
    UnitRequirements,
    JobTrack,
    UnitTrack,
    JobRequirements
}
